import Vue from 'vue';
import { formatNumber, formatNumberWithDecimals } from '@/helpers/numbers';

Vue.filter('formatNumber', (number) => {
  return formatNumber(number);
});

Vue.filter('formatNumberWithDecimals', (number, options) => {
  return formatNumberWithDecimals(number, options);
});
